module.exports = __webpack_public_path__ + "static/img/top-banner1-t.db9e954.png";


//////////////////
// WEBPACK FOOTER
// ./static/home/top-banner1-t.png
// module id = 50od
// module chunks = 1